import { render, staticRenderFns } from "./button-loader.vue?vue&type=template&id=4822b6cb"
import script from "./button-loader.vue?vue&type=script&lang=js"
export * from "./button-loader.vue?vue&type=script&lang=js"
import style0 from "./button-loader.vue?vue&type=style&index=0&id=4822b6cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports